import type { ComponentProps } from 'react'
import React from 'react'
import LoyaltyBenefitIcon from './LoyaltyBenefitIcon'
import LoyaltyTierMessageBanner from './LoyaltyTierMessageBanner'

interface Props extends ComponentProps<typeof LoyaltyTierMessageBanner> {
  benefitType: App.LoyaltyBenefitType
}

function LoyaltyTierBenefitMessageBanner({
  benefitType,
  icon,
  ...rest
}: Props) {
  return <LoyaltyTierMessageBanner
    {...rest}
    icon={icon ?? <LoyaltyBenefitIcon benefitType={benefitType} />}
  >
  </LoyaltyTierMessageBanner>
}

export default LoyaltyTierBenefitMessageBanner
